// // Main.js - Enhanced UI
// import React, { useEffect } from "react";
// import "./Main.css";
// import Chat from "../Chat/Chat";
// import { useContext } from "react";
// import { ChatContext } from "../../../contexts/ChatContext";
// import { useSelector, useDispatch } from 'react-redux';
// import { showChatArea } from "../../../redux/manageChatArea/chatAreaStatus.action";
// import { Box, Typography, Paper } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   welcomeContainer: {
//     minHeight: "650px",
//     // height: '100%',
//     width: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     background: 'linear-gradient(135deg, #899ebfff 0%, #c3cfe2 100%)',
//     padding: theme.spacing(3)
//   },
//   welcomePaper: {
//     // minHeight: "600px",
//     padding: theme.spacing(6),
//     borderRadius: theme.spacing(4),
//     textAlign: 'center',
//     maxWidth: 500,
//     background: 'rgba(255,255,255,0.95)',
//     backdropFilter: 'blur(10px)',
//     boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)'
//   },
//   iconBox: {
//     width: 80,
//     height: 80,
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     margin: '0 auto 24px',
//     boxShadow: '0 4px 20px 0 rgba(102, 126, 234, 0.4)'
//   },
//   welcomeTitle: {
//     fontWeight: 700,
//     marginBottom: theme.spacing(2),
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     backgroundClip: 'text'
//   },
//   welcomeText: {
//     color: theme.palette.text.secondary,
//     lineHeight: 1.7
//   }
// }));


// const Main = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const { showChats, showContacts } = useSelector((state) => state.manageChat);
//   const { selectedInboxId } = useContext(ChatContext);

//   useEffect(() => {
//     if (selectedInboxId !== null) {
//       dispatch(showChatArea());
//     }
//   }, [selectedInboxId, dispatch]);

//   return (
//     <Box>
//       {selectedInboxId === null ? (
//         <Box className={classes.welcomeContainer}>
//           <Paper elevation={0} className={classes.welcomePaper}>
//             <Box className={classes.iconBox}>
//               <Typography variant="h3" style={{ color: 'white' }}>💬</Typography>
//             </Box>
            
//             <Typography variant="h4" className={classes.welcomeTitle}>
//               Welcome to Chat
//             </Typography>
            
//             <Typography variant="body1" className={classes.welcomeText} style={{ color: '#000000' }}>
//               Select a conversation from the sidebar to start chatting with your team members
//             </Typography>
//           </Paper>
//         </Box>
//       ) : (
//         <Box sx={{ height: '100%', width: '100%'}}>
//           <Chat />
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default Main;


// Main.js - Enhanced UI with ChatFeatureBot tour IDs
import React, { useEffect } from "react";
import "./Main.css";
import Chat from "../Chat/Chat";
import { useContext } from "react";
import { ChatContext } from "../../../contexts/ChatContext";
import { useSelector, useDispatch } from "react-redux";
import { showChatArea } from "../../../redux/manageChatArea/chatAreaStatus.action";
import { Box, Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  welcomeContainer: {
    minHeight: "650px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #899ebfff 0%, #c3cfe2 100%)",
    padding: theme.spacing(3),
  },
  welcomePaper: {
    padding: theme.spacing(6),
    borderRadius: theme.spacing(4),
    textAlign: "center",
    maxWidth: 500,
    background: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
  },
  iconBox: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 24px",
    boxShadow: "0 4px 20px 0 rgba(102, 126, 234, 0.4)",
  },
  welcomeTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  welcomeText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.7,
  },
}));

// tourIds prop: { chatHeader, videoCall, voiceCall, messageInput, emoji, attachment, sendBtn }
const Main = ({ tourIds = {} }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showChats, showContacts } = useSelector((state) => state.manageChat);
  const { selectedInboxId } = useContext(ChatContext);

  useEffect(() => {
    if (selectedInboxId !== null) {
      dispatch(showChatArea());
    }
  }, [selectedInboxId, dispatch]);

  return (
    <Box>
      {selectedInboxId === null ? (
        <Box className={classes.welcomeContainer}>
          <Paper elevation={0} className={classes.welcomePaper}>
            <Box className={classes.iconBox}>
              <Typography variant="h3" style={{ color: "white" }}>
                💬
              </Typography>
            </Box>
            <Typography variant="h4" className={classes.welcomeTitle}>
              Welcome to Chat
            </Typography>
            <Typography
              variant="body1"
              className={classes.welcomeText}
              style={{ color: "#000000" }}
            >
              Select a conversation from the sidebar to start chatting with your
              team members
            </Typography>
          </Paper>
        </Box>
      ) : (
        <Box sx={{ height: "100%", width: "100%" }}>
          {/*
            Pass tourIds down to Chat component.
            Chat should forward them to its Header and MessageInput sub-components.
          */}
          <Chat tourIds={tourIds} />
        </Box>
      )}
    </Box>
  );
};

export default Main;